import { render, staticRenderFns } from "./additionalInfo.vue?vue&type=template&id=42a26289&scoped=true"
import script from "./additionalInfo.vue?vue&type=script&lang=js"
export * from "./additionalInfo.vue?vue&type=script&lang=js"
import style0 from "./additionalInfo.vue?vue&type=style&index=0&id=42a26289&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a26289",
  null
  
)

export default component.exports